import React from "react";
import { scroller } from "react-scroll";
import { ChevronDown } from "lucide-react";
import "./Hero.css";

export default function Hero() {
  const scrollTo = (section) => {
    scroller.scrollTo(section, { smooth: true, offset: -70, duration: 600 });
  };

  return (
    <section id="home" className="hero-section">
      <div className="hero-overlay">
        <div className="hero-content">
          <p className="eyebrow hero-eyebrow">Handcrafted in Nea Moudania, Greece</p>

          <h1>Demollari E.E.E</h1>

          <p className="hero-tagline">Where stone meets fire, form, and function.</p>

          <div className="hero-actions">
            <button type="button" className="btn" onClick={() => scrollTo("products")}>
              Explore Our Collection
            </button>
            <button type="button" className="btn btn-ghost" onClick={() => scrollTo("contact")}>
              Get In Touch
            </button>
          </div>
        </div>

        <button
          type="button"
          className="hero-scroll-cue"
          onClick={() => scrollTo("about")}
          aria-label="Scroll to About section"
        >
          <ChevronDown size={26} />
        </button>
      </div>
    </section>
  );
}
